import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onReady", "embeddedContext", "children"];
import { useEffect } from 'react';
import { IframeableContextProvider } from '../context/IframeableContext';
// @ts-expect-error Untyped import
import UIEmbeddedComponent from 'ui-addon-iframeable/embed/UIEmbeddedComponent';
import { removeConversationsWidgetWhenAvailable } from '../utils/conversationsWidget';
import { jsx as _jsx } from "react/jsx-runtime";
function IframeableContainer(_ref) {
  let {
      onReady,
      embeddedContext,
      children
    } = _ref,
    embeddedPassthruProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    onReady({
      data: {},
      receiveMessage: () => {}
    });
    // Remove conversations widget if present to prevent double loading
    removeConversationsWidgetWhenAvailable();
  }, []); /* eslint-disable-line react-hooks/exhaustive-deps */

  embeddedContext.passthruProps = {
    checkoutSession: embeddedPassthruProps.checkoutSession,
    checkoutFees: embeddedPassthruProps.checkoutFees,
    eventDate: embeddedPassthruProps.eventDate,
    eventDescription: embeddedPassthruProps.eventDescription
  };
  return /*#__PURE__*/_jsx(IframeableContextProvider, {
    iframeableContext: embeddedContext,
    children: children
  });
}

// @ts-expect-error FIXME 2026-05-11 Issue found due to ui-addon-iframeable TS migration (see #311). See `#typesafe-ui-addon-iframeable` Slack channel for more details.
export default UIEmbeddedComponent(IframeableContainer);